import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { ProfileDTO } from '@app/user-profiles/model/user-profiles-model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import {
  WhitelistDTO,
  UserDTO,
  BrandMaintenanceDTO,
  RequestEcommerceReportDTO,
  PasswordPoliciesDTO,
  EcommerceReportDTO,
  RequestEcommerceDetailReportDTO,
  RequestEcommerceDetailTPVReportDTO,
  EcommerceReportDetailDTO,
  DetailEcommerceTPVReportDTO,
  ResponseCombosAdministratorReportDTO,
  RequestAdministratorReportDTO,
  CombosReportResponseDTO,
  RequestDigitalSignatureReportDTO,
  RequestCancelSignatureDTO,
  DigitalSignatureResponseDTO,
  RequestUpdateStatesDTO,
  RequestCertificateDTO,
  CertificateResponseDTO,
  RequestDivisionDTO,
  ResponseDetailUsersDTO,
  RequestDetailUsersDTO,
  RequestUsersByFilterDTO,
  RequestActionDTO,
  ResponseBrandDTO,
  RequestBrandDTO,
  RequestAttributionsByProfileDTO,
  ResponseAttributionsByProfileDTO,
  UserDependenciesRequestDTO,
  ParentUserResponseDTO,
  ResponsePasswordDTO,
  RequestCreateUsersDTO,
  RequestVendorByFilterDTO,
  UserDetailRequestDTO,
  UserDetailResponseDTO,
  RequestDeleteUsersDTO,
  RequestModifyUsersDTO,
  ResponseImpersonatedUserDTO,
  RequestImpersonatedUserDTO,
} from '../model/users-model';

@Injectable({
  providedIn: 'root',
})
export class AdminServiceApi {
  constructor(private _http: HttpClient) {}

  postGetEntities(): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_ADMIN + environment.subUrlGetEntities, null);
  }

  postGetWhileList(whiteList: WhitelistDTO): Observable<WhitelistDTO[]> {
    return this._http.post<WhitelistDTO[]>(environment.URL_BASE_ADMIN + environment.subUrlGetWhiteList, whiteList);
  }

  postDeleteWhileList(whiteList: WhitelistDTO): Observable<boolean> {
    return this._http.post<boolean>(environment.URL_BASE_ADMIN + environment.subUrlDeleteWhileList, whiteList);
  }

  postGetWithoutWhiteList(whiteList: WhitelistDTO): Observable<UserDTO> {
    return this._http.post<UserDTO>(environment.URL_BASE_ADMIN + environment.subUrlGetWithoutWhiteList, whiteList);
  }

  postCreateWhiteList(whiteList: WhitelistDTO): Observable<boolean> {
    return this._http.post<boolean>(environment.URL_BASE_ADMIN + environment.subUrlCreateWhiteList, whiteList);
  }

  postCreateBrandMaintenance(brandMaintenanceDTO: BrandMaintenanceDTO): Observable<boolean> {
    return this._http.post<boolean>(
      environment.URL_BASE_ADMIN + environment.subUrlBrandMaintenance,
      brandMaintenanceDTO
    );
  }

  getReportsECommerce(requestEcommerceReportDTO: RequestEcommerceReportDTO): Observable<EcommerceReportDTO[]> {
    return this._http.post<EcommerceReportDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlReportsECommerce,
      requestEcommerceReportDTO
    );
  }

  getDetailECommerce(
    requestEcommerceDetailReportDTO: RequestEcommerceDetailReportDTO
  ): Observable<EcommerceReportDetailDTO> {
    return this._http.post<EcommerceReportDetailDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlReportsECommerceDetail,
      requestEcommerceDetailReportDTO
    );
  }

  getDetailECommerceTPV(
    requestEcommerceDetailTPVReportDTO: RequestEcommerceDetailTPVReportDTO
  ): Observable<DetailEcommerceTPVReportDTO> {
    return this._http.post<DetailEcommerceTPVReportDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlReportsECommerceDetailTPV,
      requestEcommerceDetailTPVReportDTO
    );
  }

  getPasswordPolicies(): Observable<PasswordPoliciesDTO> {
    return this._http.post<PasswordPoliciesDTO>(environment.URL_BASE_ADMIN + environment.subUrlPasswordPolicy, null);
  }

  // admin report

  postGetCombosReportAdministrator(): Observable<ResponseCombosAdministratorReportDTO> {
    return this._http.post<ResponseCombosAdministratorReportDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlCombosReportAdministrator,
      null
    );
  }

  postGetResultsAdminReport(adminReportDTO: any): Observable<RequestAdministratorReportDTO> {
    return this._http.post<RequestAdministratorReportDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlResultsAdminReport,
      adminReportDTO
    );
  }

  // signature report

  postGetCombosReportSignature(): Observable<CombosReportResponseDTO> {
    return this._http.post<CombosReportResponseDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlCombosReportSignature,
      null
    );
  }

  postGetResultsSignatureReport(
    signatureReportDTO: RequestDigitalSignatureReportDTO
  ): Observable<DigitalSignatureResponseDTO> {
    return this._http.post<DigitalSignatureResponseDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlResultsSignatureReport,
      signatureReportDTO
    );
  }

  postGetUpdateStates(updateStatesDTO: RequestUpdateStatesDTO): Observable<DigitalSignatureResponseDTO> {
    return this._http.post<DigitalSignatureResponseDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlResultsSignatureReport,
      updateStatesDTO
    );
  }

  postGetCertificate(CertificateDTO: RequestCertificateDTO): Observable<CertificateResponseDTO> {
    const httpOptions = { responseType: 'blob' as 'json', params: new HttpParams().set('guid', CertificateDTO.guid) };
    return this._http.post<CertificateResponseDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlPrintCertificateSignature,
      CertificateDTO,
      httpOptions
    );
  }

  postGetCancelSignatureContract(
    cancelSignatureDTO: RequestCancelSignatureDTO
  ): Observable<DigitalSignatureResponseDTO> {
    return this._http.post<DigitalSignatureResponseDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlCancelSignatureContract,
      cancelSignatureDTO
    );
  }

  postGetCancelSignatureINE(cancelSignatureDTO: RequestCancelSignatureDTO): Observable<DigitalSignatureResponseDTO> {
    return this._http.post<DigitalSignatureResponseDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlCancelSignatureINE,
      cancelSignatureDTO
    );
  }

  postGetExternalCommercial(requestDivisionDTO: RequestDivisionDTO): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlGetExternalCommercial,
      requestDivisionDTO
    );
  }

  postGetDivisions(): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_ADMIN + environment.subUrlGetDivisions, null);
  }

  postGetBrands(requestBrand: RequestBrandDTO): Observable<ResponseBrandDTO[]> {
    return this._http.post<ResponseBrandDTO[]>(environment.URL_BASE_ADMIN + environment.subUrlGetBrands, requestBrand);
  }

  postGetProfiles(requestAction: RequestActionDTO): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlGetProfilesUsers,
      requestAction
    );
  }

  postGetAttributions(
    requestActtributions: RequestAttributionsByProfileDTO
  ): Observable<ResponseAttributionsByProfileDTO[]> {
    return this._http.post<ResponseAttributionsByProfileDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlGetAttributionsUser,
      requestActtributions
    );
  }

  postGetImpersonatedUserSearch(
    userDependenciesRequest: RequestImpersonatedUserDTO
  ): Observable<ResponseImpersonatedUserDTO[]> {
    return this._http.post<ResponseImpersonatedUserDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlImpersonatedUserByFilter,
      userDependenciesRequest
    );
  }

  postGetUserType(): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_ADMIN + environment.subUrlGetUserType, null);
  }

  postSearchUsers(requestDetailUser: RequestUsersByFilterDTO): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlgetSearchUsers,
      requestDetailUser
    );
  }

  postGetVendors(requestVendor: RequestVendorByFilterDTO): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlVendorByFilter,
      requestVendor
    );
  }

  postGetPasswordWS(): Observable<ResponsePasswordDTO> {
    return this._http.post<ResponsePasswordDTO>(environment.URL_BASE_ADMIN + environment.subUrlGetPasswordWS, null);
  }

  postGetDetailUser(requestDetailUser: RequestDetailUsersDTO): Observable<ResponseDetailUsersDTO> {
    return this._http.post<ResponseDetailUsersDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlGetDetailUser,
      requestDetailUser
    );
  }

  postGetUserDetailByUserId(requestUserDetail: UserDetailRequestDTO): Observable<UserDetailResponseDTO> {
    return this._http.post<UserDetailResponseDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlGetUserDetailById,
      requestUserDetail
    );
  }

  postGetUserDetailByUserName(requestUserDetail: UserDetailRequestDTO): Observable<UserDetailResponseDTO> {
    return this._http.post<UserDetailResponseDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlGetUserDetailByUserName,
      requestUserDetail
    );
  }

  postDeleteUser(requestDelete: RequestDeleteUsersDTO): Observable<boolean> {
    return this._http.post<boolean>(environment.URL_BASE_ADMIN + environment.subUrlDeleteUser, requestDelete);
  }

  postModifyUser(requestModifyUser: RequestModifyUsersDTO): Observable<boolean> {
    return this._http.post<boolean>(environment.URL_BASE_ADMIN + environment.subUrlModifyUser, requestModifyUser);
  }

  postCreateUser(requestCreateUser: RequestCreateUsersDTO): Observable<boolean> {
    return this._http.post<boolean>(environment.URL_BASE_ADMIN + environment.subUrlCreateUser, requestCreateUser);
  }

  getProfilesByTypeBs(parameter?: string): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlTypeBsReportAdministrator,
      null,
      parameter ? { params: new HttpParams().set('typeBS', parameter) } : undefined
    );
  }

  getOffices(parameter: string): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_REQUEST + environment.subUrlOfficesByDivision, null, {
      params: new HttpParams().set('divisionId', parameter),
    });
  }

  getChainsWithoutMacrouser(parameter: string): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlChainsWithoutMacrouserByDivision,
      null,
      { params: new HttpParams().set('divisionId', parameter) }
    );
  }

  getOfficesByMacrouser(parameter: string): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_REQUEST + environment.subUrlOfficesByMacroUser, null, {
      params: new HttpParams().set('macroUser', parameter),
    });
  }

  getChainsByMacrouser(parameter: string): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_REQUEST + environment.subUrlChainsByMacroUser, null, {
      params: new HttpParams().set('macroUser', parameter),
    });
  }
  getProfilesByUserType(parameter: string): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlGetProfilesByUserType,
      null,
      parameter ? { params: new HttpParams().set('cod', parameter) } : undefined
    );
  }
}
